module.exports = __webpack_public_path__ + "images/trello-logo-blue.6e3ec398528bb59d53b0.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/trello-logo-blue.svg
// module id = FMFh
// module chunks = 2